var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"iubenda-nostyle no-brand iubenda-noiframe iubenda-embed",attrs:{"href":_vm.link,"title":_vm.label},domProps:{"textContent":_vm._s(_vm.label)},on:{"click":function($event){$event.stopPropagation();return _vm.onClick.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }